export const returnLastTwoDigitFromANumber = (number) => {
    let textString = String(number).slice(-2);
    return Number(textString)
  };